import React, { useEffect } from "react"
import { useMap } from "react-leaflet"

const RecenterAutomaticallyMap = ({ centerLatLonMap }) => {
  const map = useMap()
  useEffect(() => {
    if (!centerLatLonMap) return
    // animate:false — animated setView stranded the map mid-flight.
    map.whenReady(() => {
      map.setView(centerLatLonMap, map.getZoom(), { animate: false })
    })
  }, [centerLatLonMap, map])
  return null
}

export default RecenterAutomaticallyMap
